import React from 'react'
import Spinner from 'react-bootstrap/Spinner';

function ProgressLoad() {
    return (
        <div style={{"visibility":"visible","position":"fixed","top":"40%","left":"30%","width":"50%","zIndex":"999999"}}>
          <Spinner animation="grow" size="sm" variant="info" /> <Spinner animation="grow" size="sm" variant="success" />
          <Spinner animation="grow" size="sm" variant="info" /><Spinner animation="grow" variant="danger"/>
          <Spinner animation="grow" size="bg" variant="success"/><Spinner animation="grow" size="bg"  variant="warning" />
          <Spinner animation="grow" size="sm"  variant="secondary" /><Spinner animation="grow" size="sm"  variant="primary" />
          <Spinner animation="grow" size="sm" variant="info" /></div> 
      )
}
export default ProgressLoad;